import React from 'react'
import { TableCell, TableRow } from '@mui/material'
import { CompanyShare } from 'types/CompanyEntity'

interface ListedHistoryTableRowProps {
    date: string | null
    share: CompanyShare
    multipleInstrumentsExists?: boolean
    isSmallScreen: boolean
}

export const ListedHistoryTableRow = ({
    date,
    share,
    multipleInstrumentsExists = false,
    isSmallScreen,
}: ListedHistoryTableRowProps) => {
    return (
        <TableRow>
            <TableCell>{date}</TableCell>
            {multipleInstrumentsExists && !isSmallScreen ? <TableCell>{share.symbol}</TableCell> : null}
            <TableCell>Notering av {share.nameChanges[0]?.fromName || share.instrumentName}</TableCell>
            {!isSmallScreen ? (
                <>
                    <TableCell />
                    <TableCell />
                </>
            ) : null}
            <TableCell />
        </TableRow>
    )
}
